/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';
import { servicedate } from './servicedate';
import { procedure } from './procedure';
import { requestvalidation } from './requestvalidation';
import { referenceidentification } from './referenceidentification';
import { claimhealthcaredelivery } from '../../accounting/claim/claimhealthcaredelivery';

export class benefitinformation extends IceEntity {
  benefit_information_key: string = "";
  benefit_code: string = "";
  coverage_level_code: string = "";
  service_type_code: string = "";
  insurance_type_code: string = "";
  plan_coverage_description: string = "";
  time_period_qualifier: string = "";
  benefit_amount: number = 0.0;
  benefit_percent: number = 0.0;
  quantity_qualifier: string = "";
  quantity: number = 0.0;
  authorization_code: string = "";
  in_plan_network: string = "";
  product_service_id_qualifier: string = "";
  code: string = "";
  modifier1: string = "";
  modifier2: string = "";
  modifier3: string = "";
  modifier4: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";
  msgtxts: string = "";

  HCD: claimhealthcaredelivery[] = [];
  IDS: referenceidentification[] = [];
  ASSOCDTS: servicedate[] = [];
  ADDNLBFITS: procedure[] = [];
  REQRESULTS: requestvalidation[] = [];

  gettablename(): string {
    return "BENEFIT_INFORMATION";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "IDS") return true;
    else if (ColumnName == "HCD") return true;
    else if (ColumnName == "ASSOCDTS") return true;
    else if (ColumnName == "ADDNLBFITS") return true;
    else if (ColumnName == "REQRESULTS") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "IDS") return "REFERENCE_IDENTIFICATION";
    else if (ColumnName == "HCD") return "CLAIM_HEALTHCARE_DELIVERY";
    else if (ColumnName == "ASSOCDTS") return "SERVICE_DATE";
    else if (ColumnName == "ADDNLBFITS") return "PROCEDURE";
    else if (ColumnName == "REQRESULTS") return "REQUEST_VALIDATION";

    return null;
  }
}
